// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__2tBVP","activeLink":"Navigation_activeLink__3oWAN Navigation_link__2tBVP"};